module.exports = __webpack_public_path__ + "static/media/emo3b.94c35e60.png";